import { Controller } from "@hotwired/stimulus"

// V2 sidebar collapse. State is a cookie the server reads to render data-collapsed on the
// <aside> at first paint, so there's no expand→collapse flash on load. The collapsed styling
// is CSS-driven off that attribute, so toggling just flips it and rewrites the cookie.
export default class extends Controller {
  toggle() {
    this.setCollapsed(this.element.dataset.collapsed !== "true")
  }

  // Opening a nav group while collapsed implies opening the rail — the group's children can't render
  // in 52px (see sidebar_nav_group_controller#toggle).
  expand() {
    this.setCollapsed(false)
  }

  setCollapsed(collapsed) {
    this.element.dataset.collapsed = collapsed
    // Global (path=/), ~1 year, so the choice sticks across pages and sessions.
    document.cookie = `v2_sidebar_collapsed=${collapsed}; path=/; max-age=31536000; SameSite=Lax`
  }
}
